// NoteBookmarkList.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function NoteBookmarkListItem({noteBookmarkListItem}){ 

  const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
  const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

  const dispatch = useDispatch(); // dispatch(
  const userListItem = useSelector((state) => state.home.userListItem);

  const [open4, setOpen4] = useState(false);

  const handleOnClickChange = (noteBookmarkListItem) => {
    dispatch(setBook4Accordion1(0));
    dispatch(setNoteBookmarkListItemToBeChanged(noteBookmarkListItem));
    //dispatch(setOpen4(true));
    setOpen4(true);
    dispatch(setTab4AddChange(1));
  }

  const handleOnClickDelete = (noteBookmarkListItem) => {
    dispatch(setNoteBookmarkListItemToBeDeleted(noteBookmarkListItem));
    dispatch(setCallerConfirmationDialog('noteBookmarkListItemToBeDeleted'));
    //dispatch(setDialogTitle('確定刪除'));
    dispatch(setButtonText('刪除'));
    dispatch(setTitleToBeDeleted(`標題: ${noteBookmarkListItem.title}`));
    dispatch(setOpenConfirmationDialog(true));
  }

  return (
      <div>      
          <Grid container spacing={1}>
              <Grid
                  size={12}
                  sx={{
                      display: 'flex', // Use flexbox
                      justifyContent: 'flex-end', // Align content to the right
                      // alignItems: 'center', // Optional: Align vertically
                  }}
              >
                {/* {`${localizedDateTime(noteBookmarkListItem.revisionDateTimeHk)} (${noteBookmarkListItem.id})`} */}
                {`ID: ${noteBookmarkListItem.id}`}
              </Grid>
              <Grid size={12}>
                  <ButtonGroup 
                      // variant="outlined" 
                      size='medium'
                      sx={{
                          width: '100%',
                          display: 'flex',
                          height: 35,
                          // border: '1px solid',
                          // borderColor: 'primary.main',
                          // '& .MuiButtonGroup-grouped': { border: 'none' },
                          // '& .MuiButtonGroup-grouped:not(:last-of-type)': {
                          //     borderRight: '1px solid',
                          // },            
                      }}
                  >     

                      <Button 
                      //   variant="outlined"
                        sx={{
                          flex: 9,
                          color: 'white',
                          backgroundColor: 'primary.main',
                          // border: '1px solid',
                          // borderColor: 'primary.main',              
                          // borderRadius: 0,
                          '&:hover': { color: 'white', backgroundColor: 'primary.main' },
                          '&.Mui-disabled': { color: 'white' },
                          justifyContent: 'flex-start', // Align text to the left
                          textTransform: 'none',
                        }}   
                        disabled
                      >
                        {noteBookmarkListItem.title}
                      </Button>                                         

                      <Button 
                      //   variant="outlined"
                        sx={{
                          padding: 0,
                          flex: 0.5,
                          color: 'white',
                          backgroundColor: 'primary.main',
                          // border: '1px solid',
                          // borderColor: 'primary.main',              
                          // borderRadius: 0,
                          '&:hover': { color: 'white', backgroundColor: 'primary.main' },
                        }}                                         
                      >
                        <DeleteIcon onClick={() => handleOnClickDelete(noteBookmarkListItem)}/>
                      </Button>

                      <Button 
                      //   variant="outlined"
                        sx={{
                          padding: 0,
                          flex: 0.5,
                          color: 'white',
                          backgroundColor: 'primary.main',                          
                          // border: '1px solid',
                          // borderColor: 'primary.main',              
                          // borderRadius: 0,
                          '&:hover': { color: 'white', backgroundColor: 'primary.main' },
                        }}                                 
                      >
                        <EditDocumentIcon onClick={() => handleOnClickChange(noteBookmarkListItem)}/>
                      </Button>                      

                    </ButtonGroup>                    
              </Grid>
              <Grid size={12} sx={{pt: 2, pb: 2, pl: 1, pr: 1, borderRadius: 1, backgroundColor: theme => theme.palette.grey[200] }}>
                  {noteBookmarkListItem.noteBookmarkVerseList.map(noteBookmarkVerseList => (
                      <div>
                          <FullFormatVerse book={noteBookmarkVerseList.book} chapter={noteBookmarkVerseList.chapter} verse={noteBookmarkVerseList.verse} details={noteBookmarkVerseList.details} verseNumberOnly={false}/>
                      </div>
                  ))}
              </Grid>
              <Grid size={12} sx={{ fontSize: userListItem.VerseFontSize, lineHeight: 2, whiteSpace: 'pre-wrap' }}>
                  {noteBookmarkListItem.details}
              </Grid>

              <Grid size={6}>

              </Grid>

          </Grid>

          {/* <ConfirmationDialog /> */}
          <AddChangeNote open4={open4} setOpen4={setOpen4}/>

      </div>
  )

}